import React, { useState, useEffect } from 'react'
import {
  StyledListContainer,
  StyledUL,
  StyledLI,
  StyledSpanTitle,
  StyledHr,
  StyledTabEventTitle,
} from './style'
import moment from 'moment-timezone'
import LoadMoreButton from '../Results/components/LoadMoreButton'
import A from '@components/A'

const EventItem = ({
  id,
  title,
  eventStart,
  slug,
  category,
  ContentfulContentTypename = 'ContentfulEvent',
  color = 'purple',
  hover,
}) => {
  return (
    <StyledLI>
      <A
        to={slug}
        contentType={ContentfulContentTypename}
        category={category?.slug}
      >
        <StyledSpanTitle hover={hover} color={color}>
          {title}
        </StyledSpanTitle>
        <span style={{ color: 'black' }}>
          {` - ` + moment(eventStart).format('MMMM Do, YYYY')}
        </span>
      </A>
    </StyledLI>
  )
}

const EventsLoadMoreList = ({
  maxEventsToDisplayPerLoadMoreButton = 20,
  allowPaginationViaLoadMoreButton = false,
  title = 'Events',
  events = [],
  ContentfulContentTypename = 'ContentfulEvent',
  color = 'purple',
  hover,
}) => {
  const [numItemsToDisplay, setNumItemsToDisplay] = useState(
    maxEventsToDisplayPerLoadMoreButton
  )
  const hasMoreItems = numItemsToDisplay < events?.length

  const loadMore = () => {
    if (hasMoreItems)
      setNumItemsToDisplay(
        numItemsToDisplay + maxEventsToDisplayPerLoadMoreButton
      )
  }

  return (
    <>
      {events.length >= 1 && (
        <StyledTabEventTitle
          marginBottom={25}
          smallerText="2.5"
          upperCase
          color={'navy'}
        >
          {title}
        </StyledTabEventTitle>
      )}
      <StyledUL>
        {events?.slice(0, numItemsToDisplay)?.map(event => (
          <EventItem
            {...event}
            color={color}
            hover={hover}
            key={event.id}
            ContentfulContentTypename={ContentfulContentTypename}
          />
        ))}
      </StyledUL>
      {allowPaginationViaLoadMoreButton && hasMoreItems && (
        <LoadMoreButton
          margin="25px 0 0"
          smallerWidth="82.5%"
          loadMore={loadMore}
        />
      )}
    </>
  )
}

const EventList = ({ tabName, listContent }) => {
  const [upcoming, setUpcoming] = useState([])
  const [past, setPast] = useState([])

  useEffect(() => {
    const today = moment()
    let upcoming = []
    let past = []
    let hasPastEvents = false

    for (let i = 0; i < listContent.length; i++) {
      // if we hit a past event, we know we can separate
      // at that event our two lists
      if (listContent?.[i]?.currentTimezoneDate?.diff(today) < 0) {
        hasPastEvents = true
        past = listContent.splice(i, listContent.length)
        upcoming = listContent

        break
      } else {
        // continue for future events
        continue
      }
    }

    if (hasPastEvents) {
      setUpcoming(upcoming)
      setPast(past)
    } else {
      setUpcoming(listContent)
      setPast(past)
    }
  }, [listContent])

  return (
    <StyledListContainer>
      {upcoming && upcoming.length >= 1 && (
        <>
          <EventsLoadMoreList
            color="black"
            hover="gold"
            title="Upcoming Events"
            events={upcoming}
          />
          {past && past.length >= 1 && <StyledHr />}
        </>
      )}
      <EventsLoadMoreList
        title="Past Events"
        allowPaginationViaLoadMoreButton
        events={past}
        color="black"
        hover="gold"
      />
    </StyledListContainer>
  )
}

EventList.propTypes = {}

export default EventList
